import React from 'react';
import { Link } from 'react-router-dom';
import { qashqLogo2 } from '../assets/images';
import ScrollReveal from './ScrollReveal';

function Footer() {
  const socialLinks = [
    {
      href: 'https://www.youtube.com/channel/UCDLU344Bey3y74nw14jC4fw',
      icon: 'logo-youtube',
      label: 'YouTube',
    },
    {
      href: 'https://www.facebook.com/profile.php?id=61565421696183',
      icon: 'logo-facebook',
      label: 'Facebook',
    },
    {
      href: 'https://x.com/qashqBITC',
      icon: 'logo-x',
      label: 'X (Twitter)',
    },
    {
      href: 'https://www.linkedin.com/company/104664276',
      icon: 'logo-linkedin',
      label: 'LinkedIn',
    },
  ];

  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/services', label: 'Services' },
    { to: '/blog', label: 'Blog' },
    { to: '/contact', label: 'Contact' },
  ];

  const businessLinks = [
    'Accounting & Bookkeeping',
    'Tax Planning & Compliance',
    'Business Advisory',
    'Financial Reporting',
    'Payroll & HR Support',
  ];

  const itLinks = [
    'IT Consulting',
    'Web Development',
    'Mobile App Development',
    'Custom Software Solutions',
    'Digital Solutions',
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <ScrollReveal className="container footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-brand-link" aria-label="QASHQ home">
              <img src={qashqLogo2} alt="QASHQ" className="footer-brand-logo" />
              <span className="footer-brand-word">QASHQ</span>
            </Link>

            <p className="footer-brand-text">
              QASHQ Business &amp; IT Consultants combines financial expertise and technology
              delivery to help organizations operate with clarity, compliance, and confidence.
            </p>

            <a href="mailto:contact.qashq@gmail.com" className="footer-email">
              <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
              contact.qashq@gmail.com
            </a>

            <div className="footer-social-block">
              <p className="footer-social-title">Follow us</p>
              <ul className="social-list footer-brand-social" aria-label="Social media">
                {socialLinks.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="social-link"
                      aria-label={item.label}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ion-icon name={item.icon}></ion-icon>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="footer-columns">
            <ul className="footer-list">
              <li>
                <p className="footer-list-title">Quick Links</p>
              </li>
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="footer-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            <ul className="footer-list">
              <li>
                <p className="footer-list-title">Business Services</p>
              </li>
              {businessLinks.map((label) => (
                <li key={label}>
                  <Link to="/services" className="footer-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            <ul className="footer-list">
              <li>
                <p className="footer-list-title">IT Services</p>
              </li>
              {itLinks.map((label) => (
                <li key={label}>
                  <Link to="/services" className="footer-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            <ul className="footer-list footer-contact-list">
              <li>
                <p className="footer-list-title">Contact</p>
              </li>

              <li className="footer-item">
                <div className="footer-item-icon" aria-hidden="true">
                  <ion-icon name="call-outline"></ion-icon>
                </div>
                <div>
                  <a href="tel:+923479310319" className="footer-item-link">
                    +92 347 9310319
                  </a>
                  <a
                    href="https://wa.me/923479310319"
                    className="footer-item-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    WhatsApp
                  </a>
                </div>
              </li>

              <li className="footer-item">
                <div className="footer-item-icon" aria-hidden="true">
                  <ion-icon name="location-outline"></ion-icon>
                </div>
                <address className="footer-item-link">
                  Transformer Chowk, Sadiqabad
                  <br />
                  Rawalpindi, Pakistan
                </address>
              </li>
            </ul>
          </div>
        </ScrollReveal>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div className="footer-bottom-brand">
            <img src={qashqLogo2} alt="" className="footer-bottom-logo" aria-hidden="true" />
            <p className="copyright">
              &copy; {new Date().getFullYear()}{' '}
              <span className="copyright-link">QASHQ Business &amp; IT Consultants</span>. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
